import Image__ResizedImage from "./Image__ResizedImage";

export default function Images__ResizedImages(images, options) {
  return images.map(image => Image__ResizedImage(options, image));
}
